export default "__VITE_ASSET__178537e1__"